import { render, staticRenderFns } from "./introduceMyself.vue?vue&type=template&id=bc6edd9a&"
import script from "./introduceMyself.vue?vue&type=script&lang=js&"
export * from "./introduceMyself.vue?vue&type=script&lang=js&"
import style0 from "./introduceMyself.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports